/**
 * @module
 */

var PromiseEnv = require('../lib/promise').Promise;
var WindowEnv = require('../env/window');

/**
 * Return a Promise that rejects after the given interval.
 * @param {number} timeoutMs milliseconds
 * @returns {Promise}
 */
exports.makeTimeoutPromise = function(timeoutMs:number): Promise<any> {
  return new PromiseEnv(function(resolve, reject) {
    WindowEnv.setTimeout(function() {
      reject(new Error('Timed out after ' + timeoutMs + ' ms'));
    }, timeoutMs);
  });
};
